import { Link } from "react-router-dom";

export function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="border-t border-translator-border bg-translator-panel/30 mt-16">
            <div className="max-w-7xl mx-auto px-4 py-8">
                <div className="flex flex-col items-center space-y-4">
                    {/* Legal Links */}
                    <nav className="flex flex-wrap items-center justify-center gap-4 sm:gap-6">
                        <Link
                            to="/privacy"
                            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                        >
                            Privacy Policy
                        </Link>
                        <span className="text-muted-foreground/50 hidden sm:inline">•</span>
                        <Link
                            to="/terms"
                            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                        >
                            Terms of Service
                        </Link>
                        <span className="text-muted-foreground/50 hidden sm:inline">•</span>
                        <Link
                            to="/contact"
                            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                        >
                            Contact
                        </Link>
                    </nav>

                    {/* Tagline */}
                    <div className="text-center space-y-1">
                        <p className="text-muted-foreground text-sm">
                            AI-powered translations with seamless n8n integration
                        </p>
                        <p className="text-xs text-muted-foreground/70">
                            Built with React, TypeScript & Tailwind CSS
                        </p>
                    </div>

                    {/* Copyright */}
                    <p className="text-xs text-muted-foreground/60">
                        © {currentYear} TranslateLoo. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
}
